import { render, staticRenderFns } from "./Community.vue?vue&type=template&id=888f7d6c&scoped=true"
import script from "./Community.vue?vue&type=script&lang=js"
export * from "./Community.vue?vue&type=script&lang=js"
import style0 from "@/sass/info-responsive.scss?vue&type=style&index=0&id=888f7d6c&prod&scoped=true&lang=scss&external"
import style1 from "./Community.vue?vue&type=style&index=1&id=888f7d6c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "888f7d6c",
  null
  
)

export default component.exports